import { Breadcrumbs, Typography } from '@material-ui/core'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { cx } from 'class-variance-authority'
import { ReactNode, useMemo } from 'react'
import { useMatches } from 'react-router-dom'
import styles from './app-breadcrumbs.module.css'

type RouteHandle = {
	crumb: (match: any) => ReactNode
}

type Crumb = {
	match: {
		id: string
		handle: RouteHandle
	}
	breadcrumb: ReactNode
}

export const AppBreadcrumbs = () => {
	const matches = useMatches()

	const crumbs: Crumb[] = useMemo(() => {
		const crumbs = matches
			.filter((match) => Boolean((match as any).handle?.crumb))
			.map((match) => ({
				match: match as any,
				breadcrumb: (match as any).handle?.crumb(match) as ReactNode,
			}))

		return crumbs
	}, [matches])

	if (!crumbs.length) return null

	return (
		<Breadcrumbs separator={<NavigateNextIcon fontSize='small' style={{ color: 'white' }} />} aria-label='breadcrumb'>
			{crumbs.map((crumb, index) => {
				const isLast = index === crumbs.length - 1

				return (
					<Typography key={crumb.match.id} component='h4' className={cx(styles['text'], isLast && styles['last'])}>
						{crumb.breadcrumb}
					</Typography>
				)
			})}
		</Breadcrumbs>
	)
}
